import { render, staticRenderFns } from "./atdialog.vue?vue&type=template&id=4a083d9c&scoped=true&"
import script from "./atdialog.vue?vue&type=script&lang=js&"
export * from "./atdialog.vue?vue&type=script&lang=js&"
import style0 from "./atdialog.vue?vue&type=style&index=0&id=4a083d9c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a083d9c",
  null
  
)

component.options.__file = "atdialog.vue"
export default component.exports